import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LiapiService } from '../service/liapi.service';
import { ResourceService } from '../service/resource.service';
import $ from 'jquery';
import * as L from "leaflet";
import { UserService } from '../service/user.service';

@Component({
    selector: 'addressverification-demo',
    templateUrl: './addressverificationdemo.component.html'
})
export class AddressverificationDemoComponent implements OnInit {
    public docsURL: any = "";
    public captchaCheck: boolean = false;
    public isResReady: boolean = false;
    public resAddr: string;
    public resConf: any;
    public verifiedLevel: any;
    public resAddrQua: string;
    public resDeliver: string;
    public resAddrType: string;
    public resRecType: string;
    public resRecTypeDefault: string;
    public resCountry: string;
    public resState: string;
    public resZip: string;
    public mapOptions;
    public map;
    public mapLayers: L.Layer[];
    public addressQualityDescription: any = {C5: "Verified with correction. Delivery point confirmed to be deliverable address.", C4: "Verified with correction. House number or Building Name are within a valid range or known name but can not confirm 100% that premise is deliverable.", C3: "Verified with correction. Street name is valid but house number may not be.", C2: "Verified with correction. City exists but can not confirm street does.", C1: "Verified with correction. State exists but can not confirm City does.", C0: "Verified with correction. Can not confirm any part of address exists.", G5: "Verified using Geocode engine. Delivery point confirmed to be deliverable address.", G4: "Verified using Geocode engine. House number or Building Name are within a valid range or known name but can not confirm 100% that premise is deliverable.", G3: "Verified using Geocode engine. Street name is valid but house number may not be.", G2: "Verified using Geocode engine. City exists but can not confirm street does.", G1: "Verified using Geocode engine. State exists but can not confirm City does.", G0: "Verified using Geocode engine. Can not confirm any part of address exists.", M5: "Multiple addresses matching. Delivery point confirmed to be deliverable address.", M4: "Multiple addresses matching. House number or Building Name are within a valid range or known name but can not confirm 100% that premise is deliverable.", M3: "Multiple addresses matching. Street name is valid but house number may not be.", M2: "Multiple addresses matching. City exists but can not confirm street does.", M1: "Multiple addresses matching. State exists but can not confirm City does.", M0: "Multiple addresses matching. Can not confirm any part of address exists.", U5: "Unmatched with reference data. Delivery point confirmed to be deliverable address.", U4: "Unmatched with reference data. House number or Building Name are within a valid range or known name but can not confirm 100% that premise is deliverable.", U3: "Unmatched with reference data. Street name is valid but house number may not be.", U2: "Unmatched with reference data. City exists but can not confirm street does.", U1: "Unmatched with reference data. State exists but can not confirm City does.", U0: "Unmatched with reference data. Can not confirm any part of address exists.", V5: "Verified without change. Delivery point confirmed to be deliverable address.", V4: "Verified without change. House number or Building Name are within a valid range or known name but can not confirm 100% that premise is deliverable.", V3: "Verified without change. Street name is valid but house number may not be.", V2: "Verified without change. City exists but can not confirm street does.", V1: "Verified without change. State exists but can not confirm City does.", V0: "Verified without change. Can not confirm any part of address exists."};
    public DeliverabilityDescription: any = ["Extremely unlikely to be delivered.", "Doubt it would be delivered.", "Might be delivered.", "Should be deliverable.", "Very confident it is a deliverable address but postal service does not provide data to be 100% certain.", "Item will be delivered."];
    public addressTypeDescription: any = {F: "The address is validated or corrected to the firm name.", B: "The address is validated or corrected to the building name.", G: "The address is a general delivery address.", H: "The address is validated or corrected to the high-rise default.", L: "The address is a large volume receiver.", M: "The address is a military address.", P: "The address is validated or corrected to PO box.", R: "The address is validated or corrected to a rural route.", S: "The address is validated or corrected to a street address.", U: "The address type is unknown."};
    public recordTypeDescription: any = {"Y": "The address matches a default record.", "null": "The address does not match a default record."};
    public searchconCountry = {
      "name": "UNITED STATES OF AMERICA",
      "code": "USA",
      "label": "UNITED STATES OF AMERICA (USA)"
    };
    public searchconCountryCode = 'USA';
    countries: any[];
    filteredCountries: any[];
    public showpage: boolean = false;
    constructor(private router: Router, private activatedRoute: ActivatedRoute, private liapiservice: LiapiService, private resourceService: ResourceService, private userService: UserService) { };
    ngDoCheck() {
        if (this.searchconCountry.code) {
            this.searchconCountryCode = this.searchconCountry.code;
        }
        else {
            this.searchconCountryCode = this.searchconCountry.toString();
        }
    };
    ngOnInit() {
        this.liapiservice.getGeocodeCountries().subscribe(
            success => {
                this.countries = success;
            }
        );
        let docsURL = JSON.parse(`[{"val": "${localStorage.getItem("docsURL")}"}]`)[0].val;
        if(docsURL == "null"){
            this.resourceService.getDocsUrl().subscribe(
                success => {
                    this.docsURL = success.docsURL + "#AddressVerification/Validate_Mailing_Address_Premium/response_description.html";
                }
            );
        }
        else{
            this.docsURL = docsURL + "#AddressVerification/Validate_Mailing_Address_Premium/response_description.html";
        }
        let mapFullURL = JSON.parse(`[{"val": "${localStorage.getItem("mapFullURL")}"}]`)[0].val;
        this.initializeMapOptions(mapFullURL);
        this.userService.getUserDeatails().subscribe(
          _success => {
            this.showpage = true;
          },
          _error => {
            window.location.href = "/pricing";
          }
        );
    };
    filterCountry = function (event) {
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.countries.length; i++) {
            let country = this.countries[i];
            if (country.label.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(country);
            }
        }
        this.filteredCountries = filtered;
    };
    private initializeMapOptions(mapFullURL) {
        this.mapOptions = {
            center: L.latLng(39.828127, -98.579404),
            zoom: 4
        };
        this.mapLayers = [L.tileLayer(mapFullURL + "bronze", { maxZoom: 18, attribution: '<a rel="noopener noreferrer" target="_blank" href="http://www.openstreetmap.org/copyright">&copy; OpenStreetMap contributors</a>' })];
    }
    onMapReady(map: L.Map) {
        this.map = map;
    };
    public addressLine1 = '';
    public addressLine2 = '';
    public city = '';
    public stateProvince = '';
    public postalCode = '';
    verifyAddress = function () {
        if (!this.captchaCheck) {
            this.isResReady = false;
            $('#addrError').html('Please select "I am not a robot".');
            $('#addrError').show();
            return;
        }
        $('#verifyBtn').prop('disabled', true);
        let addressLine1: any = this.addressLine1;
        let addressLine2: any = this.addressLine2;
        let city: any = this.city;
        var country = '';
        if (this.searchconCountry != '') {
            if (this.searchconCountry.code) {
                country = this.searchconCountry.code;
            }
            else {
                country = this.searchconCountry;
            }
        }
        let stateProvince: any = this.stateProvince;
        let postalCode: any = this.postalCode;
        let postData = {
            "options": {
                "OutputCasing": "M",
                "MaximumResults": "10",
                "KeepMultimatch": "N",
                "OutputScript": "InputScript",
                "OutputAddressBlocks": "Y",
                "OutputCountryFormat": "E",
                "OutputFieldLevelReturnCodes": "N",
                "OutputRecordType": "A"
            },
            "Input": {
                "Row": [
                    {
                        "AddressLine1": addressLine1,
                        "AddressLine2": addressLine2,
                        "City": city,
                        "Country": country,
                        "StateProvince": stateProvince,
                        "PostalCode": postalCode
                    }
                ]
            }
        };
        let tmpData = {
            dataType: 'json',
            data: JSON.stringify(postData)
        };
        if (addressLine1 != '') {
            this.liapiservice.geoApiSampleDemoPostCall('/tryApiValidateMailingAddressPremiumRest', tmpData).subscribe(
                success => {
                    $('#verifyBtn').prop('disabled', false);
                    $('#addrError').hide();
                    this.isResReady = true;
                    this.resAddr = success.Output[0].BlockAddress;
                    this.resConf = success.Output[0].Confidence;
                    if (this.resConf >= 90) {
                        this.verifiedLevel = "green";
                    }
                    else if (this.resConf > 74 && this.resConf < 90) {
                        this.verifiedLevel = "blue";
                    }
                    else {
                        this.verifiedLevel = "red";
                    }
                    this.resAddrQua = success.Output[0].AddressQuality;
                    this.resDeliver = success.Output[0].Deliverability;
                    this.resAddrType = success.Output[0].AddressType;
                    if (success.Output[0].RecordType) {
                        this.resRecType = success.Output[0].RecordType;
                    }
                    else {
                        this.resRecType = "-";
                    }
                    if (success.Output[0]["RecordType.Default"]) {
                        this.resRecTypeDefault = success.Output[0]["RecordType.Default"];
                    }
                    else {
                        this.resRecTypeDefault = "null";
                    }
                    this.resCountry = success.Output[0].Country;
                    if (success.Output[0].StateProvince) {
                        this.resState = success.Output[0].StateProvince;
                    }
                    else {
                        this.resState = "-";
                    }
                    if (success.Output[0].PostalCode) {
                        this.resZip = success.Output[0].PostalCode;
                    }
                    else {
                        this.resZip = "-";
                    }
                },
                error => {
                    $('#verifyBtn').prop('disabled', false);
                    this.isResReady = false;
                    if (error.status == 401) {
                        window.location.href = "/signin";
                    }
                    if (error.error) {
                        $('#addrError').html(error.error.errors[0].errorDescription);
                    }
                    else {
                        $('#addrError').html(error.statusText);
                    }
                    $('#addrError').show();
                    if (error.status == '429') {
                      this.liapiservice.showPrimeInfo();
                      $('#addrError').hide();
                    }
                }
            );
        }
        else {
            $('#verifyBtn').prop('disabled', false);
            this.isResReady = false;
            $('#addrError').html('Invalid or missing address.');
            $('#addrError').show();
        }
    };
}
